module.exports = __webpack_public_path__ + "img/hr-V-L-5-unload-connect-shadow.6baa6f83.png";